<template>
  <ol class="strengthList strengths-list-inner text-center">
    <li v-for="(rating, index) in ratings" v-bind:key="rating.strength.name">
      <a
        @click="click(rating.strength.name)"
        href="javascript:void(0)"
        class="a-block cs-accordion-anchor a-unstyled strengths-list-item-anchor"
        :class="[fontClass(index), activeStrength === rating.strength.name ? 'active' : '']"
      >
        <div class="cs-accordion-anchor-child">
          {{ rating.strength.name }}
        </div>
      </a>

      <div
        class="cs-accordion-panel strengths-list-item-panel"
        :class="activeStrength === rating.strength.name ? 'active' : 'hidden'"
      >
        <p class="text-center strengths-list-text" style="padding: 5px 15px 15px 15px">
          {{ rating.strength.shortDefinition }}
        </p>

        <div
          class="text-center"
          v-if="showDevelopButton"
          @click="chooseStrength(rating.strength.name)"
          @keydown.enter="chooseStrength(rating.strength.name)"
        >
          <button
            class="btn btn-primary btn-lg"
            :class="{ active: rating.strength.name === chosenStrengthName }"
            type="button"
          >
            Develop {{ rating.strength.name }}
          </button>
          <p>&nbsp;</p>
        </div>
      </div>
    </li>
  </ol>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from "vue";
import { StrengthItemRatingApiModel } from "../../api-models";
import { DEFAULT_RATINGS, fontClass } from "./strengths-list-helpers";

const props = withDefaults(
  defineProps<{
    ratings: StrengthItemRatingApiModel[];
    showDevelopButton?: boolean;
    initialActiveStrengthName?: string;
    chosenStrengthName?: string;
  }>(),
  {
    ratings: () => DEFAULT_RATINGS,
    showDevelopButton: false,
    initialActiveStrengthName: "",
    chosenStrengthName: "",
  },
);

const emit = defineEmits(["choose-strength"]);

const activeStrength = ref("");

function click(name: string): void {
  if (name === activeStrength.value) {
    activeStrength.value = "";
  } else {
    activeStrength.value = name;
  }
}

watch(
  () => props.initialActiveStrengthName,
  (newValue: string) => {
    activeStrength.value = newValue;
  },
);

onMounted(() => {
  if (props.initialActiveStrengthName) {
    activeStrength.value = props.chosenStrengthName || props.initialActiveStrengthName;
  }
});

function chooseStrength(name: string): void {
  emit("choose-strength", name);
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.session {
  .strengths-list-inner {
    width: 400px;
    max-width: 95vw;
    margin-left: auto;
    margin-right: auto;
  }

  .strengths-list-text {
    width: 66.6%;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
